export default __webpack_public_path__ + "static/media/download.7b8e57f4.svg";